import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { from, Observable, throwError } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class RedirectGuard implements CanActivate {
    constructor(private authService: AuthService, private router: Router) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean | UrlTree> {
        return this.authService.userInfo$.pipe(
            take(1),
            tap((userInfo) => {
                if (userInfo.isLoggedIn) {
                    if (userInfo.isAdmin) {
                        return this.toAdmin();
                    } else if (userInfo.isGroupManager) {
                        return this.toGroup(userInfo.groupId);
                    } else {
                        return this.toPractice(userInfo.practiceId);
                    }
                }
            }),
            map(() => false) // never allow routing to .
        );
    }

    private toAdmin() {
        console.log('RedirectGuard: redirecting to admin.');
        var promise = this.router.navigateByUrl('admin');
        return from(promise);
    }

    private toPractice(practiceId: string) {
        console.log('RedirectGuard: redirecting to practice ' + practiceId + '.');
        if (practiceId) {
            var promise = this.router.navigateByUrl('practices/' + practiceId);
            return from(promise);
        } else {
            return throwError('No practiceId claim in token.');
        }
    }

    private toGroup(groupId: string) {
        console.log('RedirectGuard: redirecting to group ' + groupId + '.');
        if (groupId) {
            var promise = this.router.navigateByUrl('groups/' + groupId);
            return from(promise);
        } else {
            return throwError('No groupId claim in token.');
        }
    }
}
